import Img404 from '../assets/images/404.webp';
import PropTypes from 'prop-types';

const frontDomain = import.meta.env.VITE_FRONT_DOMAIN || "";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <>
      <div className="flex flex-col justify-center items-center gap-3 p-10">
        {/* image */}
        <div className="flex flex-col justify-center items-center -mb-8">
          <img src={Img404} alt="404" className="w-80 mt-11 md:mt-5 z-10" />
          <h1 className="text-[150px] font-bold text-blue-primary -mt-32">
            OOPS!
          </h1>
        </div>

        {/* text */}
        <h1 className="text-5xl font-bold text-blue-primary">
          Ha ocurrido un error
        </h1>
        <span className="text-xl font-semibold text-bubble-gum">
          {error.message}
        </span>

        <span className="text-xl font-semibold text-blue-primary text-center my-7">
          <br />
          Si persiste el problema, por favor contacte con nuestro{' '}
          <a href={`${frontDomain}#contacto`} className="cursor-pointer underline-offset-4 underline">
            soporte técnico
          </a>
          .
        </span>

        {/* button */}
        <button
          className="flex gap-4 justify-center items-center py-2 px-5 rounded-full text-white bg-blue-primary text-xl font-semibold"
          onClick={resetErrorBoundary}
        >
          Regresar
        </button>
      </div>
    </>
  );
};

ErrorFallback.propTypes = {
  error: PropTypes.object.isRequired,
  resetErrorBoundary: PropTypes.func.isRequired,
};

export default ErrorFallback;
